import SuperAdmin from "./layouts/super-admin";

import { useUserInfo } from "./context/user";
import NotFound from "layouts/authentication/error/404";
import { Roles } from "./enums/user";
import Integration from "layouts/integration";
import SSO from "layouts/SSO";
import localforage from "localforage";
import AgencyDashboard from "layouts/super-admin/AgencyDashboard";
import SSOCheck from "layouts/SSOCheck";

const useRoutes = () => {
  const [user] = useUserInfo();
  const pathname = window.location.pathname;
  const email = pathname.split("/")[1];
  const locationId = pathname.split("/")[2];
  if (user.email) {
    // alert("true");
  }
  const searchParams = new URLSearchParams(document.location.search);
  const sessionkey = searchParams.get("sessionkey");
  if (sessionkey != null && sessionkey != undefined) {
    localforage.setItem("sessionkey", sessionkey);
  }
  return [
    {
      type: "collapse",
      key: "not_found",
      route: "/404",
      component: <NotFound />,
    },
    {
      type: "collapse",
      key: "integration",
      route: "/integrations/*",
      component: <Integration />,
    },
    {
      type: "collapse",
      key: "integration",
      route: "/sso",
      component: <SSO />,
    },
    {
      type: "collapse",
      key: "sso_check",
      route: "/:email/:locationId/account_activation",
      component: <SSOCheck />,
    },
    {
      type: "collapse",
      key: "agency_custom_page",
      route: "/agency_custom_page/:company_id",
      component: <AgencyDashboard />,
    },
    {
      type: "collapse",
      key: "superadmin",
      route: "/:email/:locationId/*",
      component: <SuperAdmin />,
      // guard: {
      //   valid: user.email,
      //   redirect: '/404',
      // },
    },
  ];
};

export default useRoutes;
